import React from 'react'
import { connect } from 'react-redux'
import { fetchChanges } from '../../../action/changes-last-called-actions'
import { followingFetchRequest } from '../../../action/follow-list-actions'
import { huntTypesFetchRequest } from '../../../action/hunt-types-actions'
import { layersFetchRequest } from '../../../action/layer-actions'
import { markerGroupsFetchRequest } from '../../../action/marker-group-actions'
import { markerTypes105FetchRequest } from '../../../action/marker-types-105-actions'
import { markerTypes35FetchRequest } from '../../../action/marker-types-35-actions'
import { markerTypes25FetchRequest } from '../../../action/marker-types-25-actions'
import { residenceGetRequest } from '../../../action/residence-actions'
import { speciesFetchRequest } from '../../../action/species-actions'
import { userFetchRequest } from '../../../action/user-actions'
import { userSettingsGetRequest, userSettingsSet, userSettingsUpdateRequest } from '../../../action/user-settings-actions'
import { weaponTypesFetchRequest } from '../../../action/weapon-types-actions'
import { setLoading } from '../../../action/loading-actions'
import Map from '../../map'
import MainUI from '../../main-ui/'
import { collapseLeftToolbar } from '../../../action/left-toolbar-state-actions'
import { collapseRightToolbar } from '../../../action/right-toolbar-state-actions'
import { isNil } from 'lodash'
import { termsFetchRequest } from '../../../action/terms-actions'
import moment from 'moment'
import { authRefreshRequest, logout, expiredTokenLogout } from '../../../action/auth-actions'
import { getNotification } from '../../../action/notification-actions'
import { getStates } from '../../../action/state-actions'
import { markerFetchRequest } from '../../../action/marker-actions'
import { weatherActionRemove } from '../../../action/weather-action'
import { removeCenterMarker } from '../../../action/center-marker-action'
import { selectedObjectIdNull } from '../../../action/map-object-id'
import MapMarkersUpdater from './realtime-update';
import TopMenu from '../../top-menu'
// import TopMenu from '../../hunt-planner'
import { selectedTabAction } from '../../../action/selected-tab-action';
import HuntPlannerLandingPage from '../../hunt-planner/landingpage/huntPlannerLandingPage';
import { userActivePlan } from '../../../action/huntplanner-subscription-actions';
import { userHasProUltimate, userHasPro, userHasProAdvantage } from '../../../lib/util'
import { expandMorefilterMenu } from '../../../action/huntplanner-morefilters-actions'
import { huntPlannerRightMenuBarHide } from '../../../action/huntplanner-menu-bar'
import { fetchHuntPlannerLayersInitial } from '../../../action/huntplanner-state-Filter-actions'
import { isHuntPlannerEnable, isHuntPlannerDisable } from '../../../action/isHuntPlannerDisable'
import RecreationalAccess from '../../recreationAccess/landingpage/index'

class Landing extends React.Component {
  constructor(props) {
    super(props)
    this.refreshToken = this.refreshToken.bind(this)
    this.state = {
      loaderSpinner: true,
      timeCount: 0
    }
    this.timeDifference = 0
  }

  scheduleAppDataLoad = (expiresAt) => {
    collapseLeftToolbar()
    collapseRightToolbar()
    this.updateAuthToken()
    this.props.userFetchRequest()
      .then(() => this.props.followingFetchRequest())
      .then(() => this.props.fetchHuntPlannerLayersInitial())
      .then(() => this.props.userSettingsGetRequest())
      .then(() => this.props.markerGroupsFetchRequest())
      .then(() => this.props.weatherActionRemove())
      .then(() => this.props.selectedTabAction('map'))
      .then(() => this.props.isHuntPlannerDisable())
      .then(() => {
        this.props.setLoading(false)
        this.fetchSubscription()
        this.setState({ loaderSpinner: false })
      })
    this.loadAppData()
      .then(res => {
        this.validateLayers()
        getNotifications()
        this.refreshToken()
      })
      .catch(err => {
        if (err === 401) {
          logout()
          expiredTokenLogout()
        } else {
          this.fetchSubscription()
          this.loadAppData()
        }
        console.log('Initialization error: ', err)
      })

  };

  componentDidMount() {
    const { setLoading } = this.props
    setLoading(true)
    setTimeout(() => { this.scheduleAppDataLoad() }, [3 * 1000])
  }

  counterTime = (timer, fixedTime) => {
    setTimeout(() => {
      this.setState({ timeCount: timer })
      this.counterTime(timer - 10, fixedTime)
    }, [1000 * 10])
  }

  updateAuthToken = () => {
    const { expires } = this.props.auth;
    const expirationTime = new Date(expires).getTime(); // Convert expires to timestamp
    const currentTime = Date.now(); // Current timestamp
    let timeDifference = expirationTime - currentTime; // Time left in milliseconds

    if (timeDifference <= 0) {
      this.props.logout()
      return;
    } else {
      this.props.authRefreshRequest(this.clearAuthTimeout, this.userLoggedOut)
        .then((res, err) => {
          if (err) {
            return
          }
          this.checktokenExpire()
        })
    }
  }

  checktokenExpire = () => {
    const { expires } = this.props.auth;
    if (!expires) {
      return;
    }

    const expirationTime = new Date(expires).getTime(); // Convert expires to timestamp
    const currentTime = Date.now(); // Current timestamp
    let timeDifference = expirationTime - currentTime - (1000 * 60 * 2); // Time left in milliseconds  put 2 
    console.log(timeDifference, '=============>timeDifference')
    this.counterTime(timeDifference / 1000, timeDifference / 1000)
    if (timeDifference <= 0) {
      this.props.logout()
      return;
    }

    // Set timeout to trigger when token expires
    this.tokenExpireTimeout = setTimeout(() => {
      console.log('Pavan here is the issue need to change')
      // this.props.logout()
    }, timeDifference);

    // Clear timeout if needed
    return () => clearTimeout(this.tokenExpireTimeout);
  };

  validateLayers() {
    const { userSettings, layersDictionary } = this.props
    const oldActive = userSettings.find(setting => setting.settingId == 1),
      oldFavorite = userSettings.find(setting => setting.settingId == 2),
      validActive = oldActive.valueArray.filter(id => !isNil(layersDictionary[id])),
      validFavorite = oldFavorite ? oldFavorite.valueArray.filter(id => !isNil(layersDictionary[id])) : []
    if (oldActive.valueArray.length !== validActive.length || (oldFavorite && oldFavorite.valueArray.length !== validFavorite.length)) {
      const copy = userSettings.map(setting => {
        if (setting.settingId == 1) {
          setting.value = JSON.stringify(validActive)
          setting.valueArray = validActive
        } else if (setting.settingId == 2) {
          setting.value = JSON.stringify(validFavorite)
          setting.valueArray = validFavorite
        }
        return setting
      })
      if (oldActive.valueArray.length !== validActive.length) {
        userSettingsUpdateRequest(1, JSON.stringify(validActive))
      }
      if (oldFavorite && oldFavorite.valueArray.length !== validFavorite.length) {
        userSettingsUpdateRequest(2, JSON.stringify(validFavorite))
      }
      userSettingsSet(copy)
    }
  }

  refreshToken() {
    const expiry = moment.utc(this.props.auth.expires).diff(moment())
    if (expiry && expiry > 2000000000) {
      setTimeout(() => {
        this.refreshToken()
      }, 1000000)
    }
    else {
      if (expiry && expiry > 60000) {
        setTimeout(() => {
          this.props.authRefreshRequest(this.clearAuthTimeout, this.userLoggedOut)
            .then(this.refreshToken)
        }, expiry - 60000)
      } else {
        this.props.logout()
        this.props.expiredTokenLogout()
      }
    }
  }

  loadAppData() {
    return new Promise((resolve, reject) => {
      this.props.userFetchRequest()
        .then(() => this.props.layersFetchRequest())
        .then(() => this.props.markerGroupsFetchRequest())
        .then(() => this.props.markerTypes25FetchRequest())
        .then(() => this.props.markerTypes35FetchRequest())
        .then(() => this.props.markerTypes105FetchRequest())
        .then(() => this.props.huntTypesFetchRequest())
        .then(() => this.props.weaponTypesFetchRequest())
        .then(() => this.props.speciesFetchRequest())
        .then(() => this.props.residenceGetRequest())
        .then(() => this.props.termsFetchRequest())
        .then(() => this.props.getStates())
        .then(() => this.props.fetchChanges())
        .then(() => this.props.markerFetchRequest())
        .then(() => this.props.removeCenterMarker())
        .then(() => this.props.selectedObjectIdNull())
        .then(() => this.props.expandMorefilterMenu(false))
        .then(() => this.props.huntPlannerRightMenuBarHide())
        .then(() => this.props.isHuntPlannerEnable())
        .then(() => {
          resolve();
          console.log('loadAppData is resolved');
          this.fetchSubscription()
          this.props.setLoading(false)
        })
        .catch(error => {
          console.error('Error in loadAppData:', error);
          reject(error);
        });
    });
  }

  fetchSubscription() {
    const { user, userActivePlan } = this.props;
    let planId = null;
    switch (true) {
      case userHasProUltimate(user):
        planId = 44;
        break;
      case userHasProAdvantage(user):
        planId = 36;
        break;
      case userHasPro(user):
        planId = 4;
        break;
      default:
        planId = 0;
    }
    if (planId !== null) {
      userActivePlan({ id: planId });
    }
  }

  render() {
    const { loading, selectedTabvalue } = this.props;
    const { loaderSpinner } = this.state
    // Transition duration for fade effect
    const transitionDuration = 1000;  // Duration in ms

    return loading === false ?
      !loaderSpinner ? <div >
        {/* Root file for huntplanner / top menu */}
        <TopMenu />

        {/* Root file for HuntPlannerLandingPage with smooth transition */}
        <div
          style={{
            display: selectedTabvalue === 'map' ? 'none' : 'flex',
            opacity: selectedTabvalue === 'map' ? 0 : 1,
            visibility: selectedTabvalue === 'map' ? 'hidden' : 'visible',
            transition: `opacity ${transitionDuration}ms ease-in-out, visibility 0ms ${transitionDuration}ms`,  // Smooth fade transition
          }}
        >
          {selectedTabvalue == 'huntplanner' && <HuntPlannerLandingPage />}
        </div>

        <div
          style={{
            display: selectedTabvalue === 'map' ? 'none' : 'flex',
            opacity: selectedTabvalue === 'map' ? 0 : 1,
            visibility: selectedTabvalue === 'map' ? 'hidden' : 'visible',
            transition: `opacity ${transitionDuration}ms ease-in-out, visibility 0ms ${transitionDuration}ms`,  // Smooth fade transition
          }}
        >
          {selectedTabvalue == 'recreationAccess' && <RecreationalAccess />}
        </div>

        {/* Root file for Map with smooth transition */}
        <div
          style={{
            display: selectedTabvalue === 'map' ? 'flex' : 'none',
            opacity: selectedTabvalue === 'map' ? 1 : 0,
            visibility: selectedTabvalue === 'map' ? 'visible' : 'hidden',
            transition: `opacity ${transitionDuration}ms ease-in-out, visibility 0ms ${transitionDuration}ms`,  // Smooth fade transition
          }}
        >
          <Map />
        </div>

        {/* Root file for left toolbar */}
        <MainUI />
        {/* Auto api calls for objects for every 2 minutes */}
        <MapMarkersUpdater fetchChanges={() => {
          this.props.fetchChanges()
        }}></MapMarkersUpdater>
      </div>
        :
        <div className="splash-screen">
          <div className="splash-screen-spinner-container">
            <div class="loader-spinner"></div>
          </div>
        </div>
      : null
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  user: state.user,
  userSettings: state.userSettings,
  loading: state.loading,
  layersDictionary: state.layersDictionary,
  selectedTabvalue: state.selectedTab,
})

const mapDispatchToProps = dispatch => ({
  fetchChanges: () => dispatch(fetchChanges()),
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  collapseRightToolbar: () => dispatch(collapseRightToolbar()),
  followingFetchRequest: () => dispatch(followingFetchRequest()),
  huntTypesFetchRequest: () => dispatch(huntTypesFetchRequest()),
  layersFetchRequest: () => dispatch(layersFetchRequest()),
  setLoading: bool => dispatch(setLoading(bool)),
  markerGroupsFetchRequest: () => dispatch(markerGroupsFetchRequest()),
  markerTypes105FetchRequest: () => dispatch(markerTypes105FetchRequest()),
  markerTypes35FetchRequest: () => dispatch(markerTypes35FetchRequest()),
  markerTypes25FetchRequest: () => dispatch(markerTypes25FetchRequest()),
  speciesFetchRequest: () => dispatch(speciesFetchRequest()),
  residenceGetRequest: () => dispatch(residenceGetRequest()),
  userFetchRequest: () => dispatch(userFetchRequest()),
  userSettingsGetRequest: () => dispatch(userSettingsGetRequest()),
  weaponTypesFetchRequest: () => dispatch(weaponTypesFetchRequest()),
  userSettingsSet: (arr) => dispatch(userSettingsSet(arr)),
  userSettingsUpdateRequest: (id, arr) => dispatch(userSettingsUpdateRequest(id, arr)),
  termsFetchRequest: () => dispatch(termsFetchRequest()),
  authRefreshRequest: () => dispatch(authRefreshRequest()),
  logout: () => dispatch(logout()),
  getStates: () => dispatch(getStates()),
  getNotifications: () => dispatch(getNotification()),
  expiredTokenLogout: () => dispatch(expiredTokenLogout()),
  markerFetchRequest: () => dispatch(markerFetchRequest()),
  removeCenterMarker: () => dispatch(removeCenterMarker()),
  weatherActionRemove: () => dispatch(weatherActionRemove()),
  selectedObjectIdNull: () => dispatch(selectedObjectIdNull()),
  selectedTabAction: (payload) => dispatch(selectedTabAction(payload)),
  userActivePlan: (payload) => dispatch(userActivePlan(payload)),
  expandMorefilterMenu: (payload) => dispatch(expandMorefilterMenu(payload)),
  fetchHuntPlannerLayersInitial: () => dispatch(fetchHuntPlannerLayersInitial()),
  huntPlannerRightMenuBarHide: () => dispatch(huntPlannerRightMenuBarHide()),
  isHuntPlannerEnable: () => dispatch(isHuntPlannerEnable()),
  isHuntPlannerDisable: () => dispatch(isHuntPlannerDisable())
})

export default connect(mapStateToProps, mapDispatchToProps)(Landing)
